export default class Patient {

	constructor (data) {
		this.id = parseInt(data.id)
		this.watch_uid = data.watch_uid
		this.name = data.name
		this.device_type = data.device_type
		this.uptime = data.uptime
		this.last_sync = data.last_sync
		this.last_position = data.last_position
		this.online = data.online
		this.profile_id = parseInt(data.profile_id)
		this.profile_name = data.profile_name
		this.group_id = parseInt(data.group_id)
		this.picture_uid = data.picture_uid
		this.picture = data.picture
	}
}



// WEBPACK FOOTER //
// ./src/classes/Patient.js